<script>import index from "instantsearch.js/es/widgets/index/index";
import { getIndexContext, setIndexContext } from "../indexContext";
import { onDestroyClientSide } from "../utils";
export let indexName;
export let indexId = void 0;
const parentIndex = getIndexContext();
const indexWidget = index({ indexName, indexId });
parentIndex.addWidgets([indexWidget]);
setIndexContext(indexWidget);
onDestroyClientSide(() => {
  parentIndex.removeWidgets([indexWidget]);
});
</script>

<slot />
